import React from "react";
import { BsDot } from "react-icons/bs";

const PrivacyPolicy = () => {
  return (
    <div className="w-[90%] mx-auto pt-[15%] lg:pt-[5%] md:pt-[5%] pb-[15%] lg:pb-[5%] md:pb-[5%] md:w-[84%] mb-[25%] md:mb-[15%] border-t-[3px] border-b-[3px] border-[#d9d9d9]">
      <div className="flex flex-col gap-[20px] lg:gap-[25px]">
        <h2 className="text-[20px] leading-[30px] font-bold text-center md:text-[10px] md:leading-[15px] pb-[10px] lg:text-[18px] lg:leading-[27px] lg:pb-[25px]">
          PRIVACY POLICY AGREEMENT
        </h2>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px] md:w-[75%]">
          This Privacy Policy Agreement ("Agreement") is entered into between
          AremxyPlug Business Ent, LTD ("AremxyPlug," "we," "us," or "our") and
          the users ("you" or "your") of our website, products, and services.
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          This Agreement outlines how we collect, use, disclose, and protect
          your personal information when you interact with AremxyPlug's website,
          digital businesses, telecom products, payments, card issuing, digital
          products and services, information and communication, e-commerce,
          telecommunication, information and technology, VTU software, and
          business development ("Services").
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          1. <span className="font-bold">CONSENT TO THE PRIVACY POLICY:</span>{" "}
          By accessing and using our Services, you acknowledge that you have
          read, understood, and agreed to the terms and conditions of this
          Privacy Policy Agreement. If you do not agree to any part of this
          Agreement, please refrain from using our Services.
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          2.{" "}
          <span className="font-bold">COLLECTION OF PERSONAL INFORMATION:</span>{" "}
          We may collect personal information from you through various channels,
          including but not limited to our website, registration forms, surveys,
          product purchases, and customer support interactions. The types of
          personal information we collect may include your name, email address,
          contact number, payment details, and any other information you
          voluntarily provide to us.
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          <>
            <span className="font-bold">3. USE OF PERSONAL INFORMATION.</span>{" "}
            We use the personal information collected from you for the following
            purposes:
            <ul className="mt-[10px] flex flex-col gap-[5px] md:mt-[20px] md:gap-[10px] lg:mt-[25px]">
              <li className="flex gap-[3px] items-center">
                <BsDot className="text-[18px] lg:text-[24px]" />
                <p>Providing and improving our Services</p>
              </li>
              <li className="flex gap-[3px] items-center">
                <BsDot className="text-[18px] lg:text-[24px]" />
                <p>
                  Communicating with you regarding our Services, promotions, and
                  updates
                </p>
              </li>
              <li className="flex gap-[3px] items-center">
                <BsDot className="text-[18px] lg:text-[24px]" />
                <p>
                  Responding to your inquiries and providing customer support
                </p>
              </li>
              <li className="flex gap-[3px] items-center">
                <BsDot className="text-[18px] lg:text-[24px]" />
                <p>
                  Analyzing and enhancing our business operations and user
                  experience
                </p>
              </li>
              <li className="flex gap-[3px] items-center">
                <BsDot className="text-[18px] lg:text-[24px]" />
                <p>
                  Complying with legal obligations and enforcing our terms of
                  service
                </p>
              </li>
            </ul>
          </>
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          4.{" "}
          <span className="font-bold">DISCLOSURE OF PERSONAL INFORMATION:</span>{" "}
          We may disclose your personal information to third parties in the
          following circumstances.
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          5. <span className="font-bold">SERVICE PROVIDERS: </span>We may engage
          trusted third-party service providers to assist us in delivering our
          Services. These providers are contractually obligated to maintain the
          confidentiality and security of your personal information.
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          6. <span className="font-bold">LEGAL COMPLIANCE: </span> We may
          disclose your personal information if required to do so by law or if
          we believe that such action is necessary to comply with legal
          obligations, protect our rights and interests, or investigate
          potential violations.
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          7. <span className="font-bold">BUSINESS TRANSFERS: </span>In the event
          of a merger, acquisition, or sale of all or a portion of our assets,
          your personal information may be transferred as part of the
          transaction. We will notify you via email or prominent notice on our
          website before your information is transferred.
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          8. <span className="font-bold">SECURITY MEASURES: </span>We take
          reasonable steps to protect your personal information from
          unauthorized access, loss, misuse, or alteration. However, no method
          of transmission over the internet or electronic storage is entirely
          secure. Therefore, we cannot guarantee the absolute security of your
          information.
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          9.{" "}
          <span className="font-bold">RETENTION OF PERSONAL INFORMATION: </span>
          We retain your personal information for as long as necessary to
          fulfill the purposes outlined in this Privacy Policy, unless a longer
          retention period is required or permitted by law.
        </p>
        <div className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          <h2 className="mb-[5px] font-bold">COOKIES SESSION</h2>
          <p className="mb-[10px]">
            AremxyPlug uses session cookies on its website. Cookies are small
            text files that are placed on your device when you visit a website.
            Session cookies are temporary and are deleted once you close your
            browser.
          </p>
          <ul className="flex flex-col gap-[20px]">
            <p>We use session cookies for the following purposes:</p>
            <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
              i. <span className="font-bold">SESSION MANAGEMENT: </span>Session
              cookies are essential for managing your session on our website.
              They enable you to navigate between different pages and access
              secure areas of the site. These cookies do not collect any
              personal information and are necessary for the proper functioning
              of the website.
            </p>
            <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
              ii. <span className="font-bold">WEBSITE PERFORMANCE: </span>We may
              use session cookies to gather information about how you interact
              with our website, such as the pages you visit and any error
              messages you encounter. This data helps us improve the performance
              and usability of our website.
            </p>
            <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
              iii. <span className="font-bold">USER PREFERENCES: </span>Session
              cookies may be used to remember certain preferences you have
              selected.
            </p>
          </ul>
        </div>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          <span className="font-bold">UPDATES TO THE PRIVACY: </span>We may
          update this Privacy Agreement from time to time to reflect changes in
          our practices or legal requirements. We will notify you of any
          material changes by posting the revised Agreement on our website or
          sending you an email. Your continued use of our Services after the
          effective date of the revised Agreement constitutes your acceptance of
          the updated terms.
        </p>
        <p className="text-[10px] leading-[15px] text-justify font-medium lg:text-[16px] lg:leading-[24px]">
          <span className="font-bold">CONTACT INFORMATION: </span>If you have
          any questions, concerns, or requests regarding this Privacy Policy
          Agreement, please contact us at: hello@aremxyplug.com
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
